<template>
  <div>
    <!-- as cores do conteudo notificado seguirão as cores das categorias (cat1, cat2 e etc) -->
    <template v-for="(notificacao, index) in notificacoes">
      <div class="dropdown-divider"></div>
      <notificacao-item :key="'notif-' + index"
                        :titulo="notificacao.titulo"
                        :descricao="notificacao.descricao"
                        :data="notificacao.data"
                        :url="notificacao.url" />
    </template>
    <a href="#">ver todas</a>
  </div>
</template>

<script>
import NotificacaoItem from '@/components/notificacoes/NotificacaoItem'

export default {
  name: 'Notificacoes',
  components: { NotificacaoItem },
  data () {
    return {
      notificacoes: [
        { titulo: 'Categoria 1', descricao: 'Lorem ipsum dolor sit amet', data: 'ontem', url: '#' },
        { titulo: 'Categoria 2', descricao: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', data: '2 dias atrás', url: '#' },
        { titulo: 'Categoria 3', descricao: 'Consectetur adipiscing elit', data: '2 dias atrás', url: '#' }
      ]
    }
  }
}
</script>

<style scoped>

</style>
